import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    justifyContent: 'flex-start',
    marginLeft: 10,
  },
  subContainer: {marginLeft: 10, width: '70%'},
  textStyle: {
    textAlign: 'left',
  },
  titleStyle: {flex: 1},
  subText: {marginVertical: 5},
  dropText: {
    textAlign: 'left',
  },
});
